import CatalogsServices from "@/services/CatalogsServices";
import ComunServices from "@/services/ComunServices";
import vm from '@/main.js'
import { stat } from "fs";
const state = {
    loadingCatalogs: false,
    catalogsBroker: [],
    catalogsGender: [],
    catalogsCivilStatus: [],
    catalogsProvince: [],
    catalogsCanton: [],
    catalogsCity: [],
    catalogsNacionalities: [],
    catalogsVehicleBrands: [],
    catalogsVehicleModels: [],
    catalogsPaymentMethodByGrouper: [],
    catalogsPaymentMethodByPersonType: [],
    catalogsPaymentMethodRamo: [],
    catalogsTypeCoverage: [],
    catalogsAutototalGroupers: [],
    catalogsTypesIdentification: [],
    catalogsTypesPerson:[],
    catalogsRamosToEmit: [],
    catalogsTypeMovements: [],
    policyDetail: [],
    catalogsQuota: [],
    catalogsDesicion: [],
    catalogsEmisionToEmit:[],
    catalogsGestorFvc: [],
    catalogsProduct: [],
};

const getters = {
    loadingCatalogs: state => {
        return state.loadingCatalogs;
    },
    catalogsBroker: state => {
        return state.catalogsBroker;
    },
    catalogsGender: state => {
        return state.catalogsGender;
    },
    catalogsCivilStatus: state => {
        return state.catalogsCivilStatus;
    },
    catalogsProvince: state => {
        return state.catalogsProvince;
    },
    catalogsCanton: state => {
        return state.catalogsCanton;
    },
    catalogsCity:state=>
    {
        return state.catalogsCity;
    },
    catalogsNacionalities:state=>{
        return state.catalogsNacionalities;
    },
    catalogsVehicleBrands: state => {
        return state.catalogsVehicleBrands;
    },
    catalogsVehicleModels: state => {
        return state.catalogsVehicleModels;
    },
    catalogsPaymentMethodByGrouper: state => {
        return state.catalogsPaymentMethodByGrouper;
    },
    catalogsPaymentMethodByPersonType: state => {
        return state.catalogsPaymentMethodByPersonType;
    },
    
    catalogsPaymentMethodRamo: state => {
        return state.catalogsPaymentMethodRamo;
    },
    catalogsTypeCoverage: state => {
        return state.catalogsTypeCoverage;
    },
    catalogsAutototalGroupers: state => {
        return state.catalogsAutototalGroupers;
    },
    catalogsTypesIdentification: state => {
        return state.catalogsTypesIdentification;
    },
    catalogsTypesPerson : state => {
        return state.catalogsTypesPerson;
    },
    catalogsRamosToEmit: state => {
        return state.catalogsRamosToEmit;
    },
    catalogsProduct: state => {
        return state.catalogsProduct;
    },
    catalogsTypeMovements: state => {
        return state.catalogsTypeMovements;
    },
    policyDetail: state => {
        return state.policyDetail;
    },
    catalogsQuota: state => {
        return state.catalogsQuota;
    },
    catalogsDesicion: state => {
        return state.catalogsDesicion;
    },
    catalogsGestorFvc: state => {
        return state.catalogsGestorFvc;
    },    
    catalogsEmisionToEmit: state => {
        return state.catalogsEmisionToEmit;
    },
};

const actions = {
    getCatalogsBroker(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllBroker()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsBroker = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getCatalogsGender(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllGenders()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsGender = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getCatalogsCivilStatus(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllCivilStatus()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsCivilStatus = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getCatalogsNationality(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllNacionalities()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsNacionalities = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getCatalogsProvince(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getProvinces()
            .then(response => {
                if (response.data.error == 0) {
                    for(let i=0;i<response.data.data.length;i++)
                    {
                        response.data.data[i].value=response.data.data[i].value.toUpperCase()
                        response.data.data[i].code=response.data.data[i].code.toUpperCase()
                    }
                    state.catalogsProvince = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getCatalogsCanton(context,province) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getCantonByProvince(province)
            .then(response => {
                if (response.data.error == 0) {
                    for(let i=0;i<response.data.data.length;i++)
                    {
                        response.data.data[i].value=response.data.data[i].value.toUpperCase()
                        response.data.data[i].code=response.data.data[i].code.toUpperCase()
                    }
                    state.catalogsCanton = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getCatalogsCityByProvince(context,province)
    {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getCityByProvince(province)
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsCity = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno: " + response.data.msg, "error");
                }
            })
    },
    getCatalogsVehicleBrands(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllVehicleBrands()
            .then(response => {
                if (response.data.error == 0) {
                    //remapear
                    state.catalogsVehicleBrands = response.data.data.map(c => ({
                        value: c.value,
                        code: c.code
                    }));

                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getCatalogsVehicleModels(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllVehicleModels()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsVehicleModels = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },

    getQuota(context){
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getQuota()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsQuota = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });    
    },

    getCatalogsPaymentMethodByGrouper(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllPaymentMethodByGrouper()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsPaymentMethodByGrouper = response.data.data.filter(({code}) => (code == "4" || code == "6" || code == "11")  );
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getCatalogsPaymentMethodByPersonType(context, payload) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllPaymentMethodByPersonType(payload)
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsPaymentMethodByPersonType = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getCatalogsPaymentMethodRamo(context, payload) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllPaymentMethodRamo(payload)
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsPaymentMethodRamo = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getCatalogsTypeCoverage(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllTypeCoverage()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsTypeCoverage = response.data.data.filter(({code}) => (code == "2" || code == "1" )  );
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getAllAutototalGroupers(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllAutototalGroupers()
            .then(response => {
                if (response.data.error == 0) {
                    //remapear
                    
                    state.catalogsAutototalGroupers = response.data.data;
                    /*.map(c => ({
                                            value: c.value,
                                            code: c.value,
                                            personType: c.personType
                                        }));*/
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },

    getAllTypesIdentification(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllTypesIdentification()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsTypesIdentification = response.data.data.filter(({code}) => (code == "C" || code == "R" || code == "P")  );
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getAllTypesPerson(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllTypesPerson()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsTypesPerson = response.data.data.filter(({code}) => (code != "E")  );
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },  
    getCatalogsAllRamosToEmit(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllRamosToEmit()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsRamosToEmit = response.data.data.filter(({code}) => (code != "1"  && code != "23" && code != "27" && code != "29" && code != "28" && code != "31" && code != "33" && code != "41" && code != "42")  );
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getCatalogsAllProducts(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllProduct()
            .then(response => {                
                if (response.data.error == 0) {                   
                    state.catalogsProduct = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getCatalogsAllTypeEmisionToEmit(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllTipeEmisionToEmit()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsEmisionToEmit = response.data.data.filter(d => d.code != "4");
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getCatalogsTypeMovements(context) {
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllTypeMovements()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsTypeMovements = response.data.data.filter(({code}) => (code != "2"  && code != "5" && code != "12" && code != "16")  );
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getPolicyDetail(context, payload) {
        context.commit("showLoadingCatalogsIndicator");
        /*payload = {
            numPolicy: "1007921",
            identification: "0922042825"
        };*/
        return CatalogsServices.getPolicyDetail(payload.numPolicy, payload.identification)
            .then(response => {
                //console.log(response.data)
               /*  if (response.data.error == 0) {
                    state.policyDetail = response.data.data;
                    return response.data.error;
                } else if (response.data.error == 100) {
                    //vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                    
                    return response.data.error;
                } */
                return response.data.error;
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getcatalogsDesicion(context){
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getCatalogsDesicion()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsDesicion = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    },
    getcatalogsGestorFvc(context){
        context.commit("showLoadingCatalogsIndicator");
        return CatalogsServices.getAllGestorFvc()
            .then(response => {
                if (response.data.error == 0) {
                    state.catalogsGestorFvc = response.data.data;
                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingCatalogsIndicator");
            });
    }
    
};



const mutations = {
    showLoadingCatalogsIndicator(state) {
        state.loadingCatalogs = true;
    },
    hideLoadingCatalogsIndicator(state) {
        state.loadingCatalogs = false;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};